import React from 'react';
import { ArrowRight, Play } from 'react-feather';

interface IFeatureBannerProps {
  title: string;
  description: string;
  badge?: string;
  image: string;
  onTryNow?: () => void;
  onWatchDemo?: () => void;
}

const FeatureBanner: React.FC<IFeatureBannerProps> = ({
  title,
  description,
  badge = 'New Feature',
  image,
  onTryNow,
  onWatchDemo
}) => {
  return (
    <div className="kh-feature-banner">
      <div className="kh-feature-banner__content">
        <span className="kh-feature-banner__badge">{badge}</span>
        <h2 className="kh-feature-banner__title">{title}</h2>
        <p className="kh-feature-banner__description">{description}</p>
        <div className="kh-feature-banner__actions">
          <button className="kh-feature-banner__btn kh-feature-banner__btn--primary" onClick={onTryNow}>
            Try It Now <ArrowRight size={18} />
          </button>
          <button className="kh-feature-banner__btn kh-feature-banner__btn--secondary" onClick={onWatchDemo}>
            <Play size={18} /> Watch Demo
          </button>
        </div>
      </div>
      <div className="kh-feature-banner__image">
        <img src={image} alt={title} />
      </div>
    </div>
  );
};

export default FeatureBanner;
